import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Button } from './Button';
export function OfferSection() {
  return <section id="precio" className="bg-white py-16 md:py-24 px-4" data-id="element-132">
      <div className="max-w-4xl mx-auto text-center" data-id="element-133">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-stone-900 mb-6" data-id="element-134">
          Recupere la seguridad de una mente clara hoy mismo
        </h2>
        <p className="text-xl text-stone-700 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-135">
          El acceso completo a la "Memoria de Oro: Guía Anti-Olvidos" tiene una
          inversión única de solo{' '}
          <strong className="text-stone-900" data-id="element-136">
            $6.36 USD por tiempo limitado
          </strong>
          . Es menos de lo que cuesta una cena, pero el beneficio dura toda la
          vida.
        </p>

        <div className="bg-amber-50 border-2 border-amber-200 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto" data-id="element-137">
          <img src="https://cdn.magicpatterns.com/uploads/hUosK1GzFoJxwPQmiiGqeN/heylloyd-image-Memoria_de_oro.png" alt="Memoria de Oro" className="w-48 h-auto mx-auto mb-8 rounded-lg shadow-md" data-id="element-138" />
          <div className="text-6xl font-bold text-stone-900 mb-2" data-id="element-139">$6.36</div>
          <div className="mb-8 flex items-center justify-center gap-2" data-id="element-140">
            <span className="text-lg text-stone-400 line-through" data-id="element-141">
              Precio regular: $19.99
            </span>
            <span className="bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-142">
              ¡EN OFERTA!
            </span>
          </div>
          <Button fullWidth className="mb-6" data-id="element-143">
            Quiero Mi Guía Ahora — $6.36
          </Button>
          <div className="flex items-center justify-center text-stone-600" data-id="element-144">
            <ShieldCheckIcon className="w-5 h-5 mr-2 text-green-600" data-id="element-145" />
            <span data-id="element-146">Tu compra es segura y el acceso es inmediato.</span>
          </div>
        </div>
      </div>
    </section>;
}